/** The CMS schema uses a required deadline; publication does not mean open. */
export function tenderDeadline(value) {
    const date = value ? new Date(value) : null;
    return date && !Number.isNaN(date.getTime()) ? date : null;
}

export function isOpenTender(item, now = Date.now()) {
    const deadline = tenderDeadline(item?.fields?.deadline);
    return deadline ? deadline.getTime() > now : false;
}

export function tenderStatus(item, now = Date.now()) {
    const deadline = tenderDeadline(item?.fields?.deadline);
    if (!deadline) return { label: 'Deadline unavailable', tone: 'closed' };
    const remaining = deadline.getTime() - now;
    if (remaining <= 0) return { label: 'Closed', tone: 'closed' };
    const days = Math.ceil(remaining / 86400000);
    return days <= 7
        ? { label: days === 1 ? 'Closes within 24 hours' : `Closes in ${days} days`, tone: 'closing' }
        : { label: 'Open', tone: 'open' };
}

export function tenderQuery({ archive, page, term, sort, cutoff }) {
    const where = { deadline: { [archive ? '$lte' : '$gt']: cutoff } };
    if (term.trim()) where.$or = ['name', 'code', 'tenderSource'].map(field => ({
        [field]: { $containsi: term.trim() },
    }));
    return {
        content_type: 'tenders', limit: 12, skip: (page - 1) * 12,
        order: sort, where,
    };
}

export function formatTenderDeadline(value) {
    const date = tenderDeadline(value);
    return date ? new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Asia/Dili', day: 'numeric', month: 'short', year: 'numeric',
        hour: '2-digit', minute: '2-digit', hour12: false,
    }).format(date) : 'Not specified';
}
